import { useMutation, useQuery, } from "react-query";
import DataService from '../../../config/DataServices'
import { queryClient } from "../../../config";

const { getRequest, postRequest } = DataService()

export const useGetTransaction = ({ page, size, searchText, sortOrder, sortField, type, currency, network }) => {

    return useQuery({
        queryKey: ["historyList-list", page, size, searchText, sortOrder, sortField, type, currency, network],
        queryFn: () => {
            return getRequest(`/user-transactions?page=${page}&size=${size}&search=${searchText}&sortOrder=${sortOrder}&sortField=${sortField}&type=${type}&network=${network}&currency=${currency}`)
        }
    })
}

export const useUpdateCurrency = () => {

    return useMutation({
        mutationFn: (data) => {
            return postRequest("/admin-update-reqsent", { ...data })
        },

        onSuccess: success => {
            queryClient.refetchQueries('historyList-list')

        }
    })
}








